import { render, staticRenderFns } from "./Vkontakte.vue?vue&type=template&id=54998cab&scoped=true"
import script from "./Vkontakte.vue?vue&type=script&lang=js"
export * from "./Vkontakte.vue?vue&type=script&lang=js"
import style0 from "./Vkontakte.vue?vue&type=style&index=0&id=54998cab&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54998cab",
  null
  
)

export default component.exports